import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Icon from "../AppIcon";
import Button from "./Button";
import Logo from "../../assets/Logo.webp";
import toast from "react-hot-toast";

const Sidebar = ({ isCollapsed = false, isMobileOpen, setIsMobileOpen }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const [isHelpOpen, setIsHelpOpen] = useState(false);

  const navigationItems = [
    { label: "Dashboard", path: "/dashboard", icon: "LayoutDashboard", tooltip: "Overview and system status" },
    // { label: "Bot Marketplace", path: "/dashboard/bot-marketplace", icon: "Store", tooltip: "Discover and deploy trading bots" },
    { label: "Bot Creation", path: "/dashboard/bot-creation-wizard", icon: "Wrench", tooltip: "Build custom trading strategies" },
    // {
    //   label: "Strategy Testing",
    //   path: "/dashboard/backtesting-engine",
    //   icon: "TrendingUp",
    //   tooltip: "Backtest and paper trade strategies",
    //   subItems: [
    //     { label: "Backtesting Engine", path: "/dashboard/backtesting-engine", icon: "BarChart3" },
    //     { label: "Paper Trading", path: "/dashboard/paper-trading", icon: "FileText" },
    //   ],
    // },
    { label: "Bot Analytics", path: "/dashboard/bot-analytics", icon: "Activity", tooltip: "Performance monitoring and optimization" },
    // { label: "Quant Tools", path: "/dashboard/calculator", icon: "Settings", tooltip: "Quantitative analysis tools" },
    { label: "API Credentials", path: "/dashboard/api", icon: "Key", tooltip: "Manage your API keys securely" },
    { label: "Subscription", path: "/dashboard/subscription", icon: "Package", tooltip: "Manage your API keys securely" },
    { label: "Profile", path: "/dashboard/profile", icon: "User", tooltip: "Update personal information and preferences" },
  ];

  const isActiveRoute = (path) => location?.pathname === path;
  const isParentActive = (item) => item?.subItems?.some((sub) => location?.pathname === sub?.path);

  const handleNavigation = (path) => {
    navigate(path);
    setIsHelpOpen(false);
    setIsMobileOpen(false);
  };

  const handleHelpAction = (action) => {

    setIsHelpOpen(false);
  };

  const handleAccountAction = (action) => {

    navigate('/')
    toast.success("Logged out successfully!")
    localStorage.clear()

  };

  return (
    <>

      <aside
        className={`fixed top-0 left-0 h-full bg- border-r border-border z-50 bg-secondary trading-transition
          ${isCollapsed ? "w-16" : "w-72"}
          ${isMobileOpen ? "translate-x-0" : "-translate-x-full"} 
          lg:translate-x-0`}
      >
        <div className="flex flex-col h-full">
          {/* Logo (desktop only) */}
          <div className="flex items-center h-16 px-4 border-b border-border-secondary">
            {!isCollapsed ? (
              <div className="flex items-center space-x-3 m-3 justify-center">
                <img src={Logo} alt="Logo" />
              </div>
            ) : (
              <div className="w-8 h-8 bg-primary rounded-lg flex items-center justify-center mx-auto">
                <Icon name="Bot" size={20} className="text-primary-foreground" />
              </div>
            )}
          </div>

          {/* Navigation */}
          <nav className="flex-1 p-4 space-y-2 overflow-y-auto">
            {navigationItems?.map((item) => (
              <div key={item.path}>
                <div className="relative group">
                  <Button
                    variant={isActiveRoute(item.path) || isParentActive(item) ? "secondary" : "ghost"}
                    onClick={() => handleNavigation(item.path)}
                    className={`w-full justify-start h-12 ${isCollapsed ? "px-3" : "px-4"} ${isActiveRoute(item.path) || isParentActive(item)
                        ? "bg-primary/10 text-primary border-l-2 border-primary"
                        : "hover:bg-gray-300 hover:text-black"
                      }`}
                  >
                    <Icon
                      name={item.icon}
                      size={20}
                      className={
                        isActiveRoute(item.path) || isParentActive(item)
                          ? "text-primary"
                          : "text-muted-foreground"
                      }
                    />
                    {!isCollapsed && (
                      <>
                        <span className="ml-3 font-medium">{item.label}</span>
                        {item.badge && (
                          <span className="ml-auto bg-primary text-primary-foreground text-xs px-2 py-1 rounded-full">
                            {item.badge}
                          </span>
                        )}
                      </>
                    )}
                  </Button>

                  {/* Tooltip (collapsed only) */}
                  {isCollapsed && (
                    <div className="absolute left-full top-1/2 -translate-y-1/2 ml-2 px-3 py-2 bg-popover text-popover-foreground text-sm rounded-lg border border-border opacity-0 group-hover:opacity-100 pointer-events-none trading-transition z-50">
                      {item.tooltip}
                      <div className="absolute left-0 top-1/2 -translate-y-1/2 -translate-x-1 w-2 h-2 bg-popover border-l border-t border-border rotate-45" />
                    </div>
                  )}
                </div>

                {/* Sub-items */}
                {item.subItems && !isCollapsed && (isActiveRoute(item.path) || isParentActive(item)) && (
                  <div className="ml-6 mt-2 space-y-1">
                    {item.subItems.map((subItem) => (
                      <Button
                        key={subItem.path}
                        variant={isActiveRoute(subItem.path) ? "secondary" : "ghost"}
                        onClick={() => handleNavigation(subItem.path)}
                        className={`w-full justify-start h-10 px-4 ${isActiveRoute(subItem.path)
                            ? "bg-primary/5 text-primary"
                            : "hover:bg-muted text-muted-foreground"
                          }`}
                      >
                        <Icon
                          name={subItem.icon}
                          size={16}
                          className={isActiveRoute(subItem.path) ? "text-primary" : "text-muted-foreground"}
                        />
                        <span className="ml-3 text-sm">{subItem.label}</span>
                      </Button>
                    ))}
                  </div>
                )}
              </div>
            ))}
          </nav>

          {/* Help Section */}
          <div className="p-4 border-t border-border-secondary relative">
            {/* <Button
              variant="ghost"
              onClick={() => setIsHelpOpen(!isHelpOpen)}
              className={`w-full justify-start h-12 ${isCollapsed ? "px-3" : "px-4"}`}
            >
              <Icon name="HelpCircle" size={20} className="text-muted-foreground" />
              {!isCollapsed && (
                <>
                  <span className="ml-3 font-medium">Help & Support</span>
                  <Icon
                    name="ChevronUp"
                    size={16}
                    className={`ml-auto trading-transition ${isHelpOpen ? "rotate-180" : ""}`}
                  />
                </>
              )}
            </Button> */}

            <div className="p-2 border-t border-border-secondary">
              <Button
                variant="ghost"
                onClick={() => handleAccountAction('logout')}
                className="w-full justify-start text-error hover:text-error hover:bg-error/10"
              >
                <Icon name="LogOut" size={16} className="mr-3" />
                Sign Out
              </Button>
            </div>

            {isHelpOpen && !isCollapsed && (
              <div className="absolute bottom-full left-0 right-0 mb-2 bg-popover border border-border rounded-lg trading-shadow z-50">
                <div className="p-2">
                  <Button variant="ghost" onClick={() => handleHelpAction("tutorials")} className="w-full justify-start">
                    <Icon name="PlayCircle" size={16} className="mr-3" />
                    Video Tutorials
                  </Button>
                  <Button variant="ghost" onClick={() => handleHelpAction("documentation")} className="w-full justify-start">
                    <Icon name="BookOpen" size={16} className="mr-3" />
                    Documentation
                  </Button>
                  <Button variant="ghost" onClick={() => handleHelpAction("community")} className="w-full justify-start">
                    <Icon name="Users" size={16} className="mr-3" />
                    Community Forum
                  </Button>
                  <Button variant="ghost" onClick={() => handleHelpAction("contact")} className="w-full justify-start">
                    <Icon name="MessageCircle" size={16} className="mr-3" />
                    Contact Support
                  </Button>
                </div>
              </div>
            )}

           
          </div>
        </div>
      </aside>

      {/* ✅ Overlay for mobile when sidebar open */}
      {isMobileOpen && (
        <div className="fixed inset-0 bg-black/50 z-40 lg:hidden" onClick={() => setIsMobileOpen(false)} />
      )}

      {/* Click outside help (above sidebar) */}
      {isHelpOpen && (
        <div className="fixed inset-0 z-[60]" onClick={() => setIsHelpOpen(false)} />
      )}
    </>
  );
};

export default Sidebar;
